import { TDeviceInfo } from "@website/utils/device-info/device-info.types";
import memoize from "lodash-es/memoize";
import UAParser from "ua-parser-js";

export const getDeviceInfo = memoize((): TDeviceInfo => {
  const deviceInformation = new UAParser().getResult();

  if (!deviceInformation.device.type) {
    deviceInformation.device.type = "desktop";
  }

  return deviceInformation;
});
